import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import _ from 'lodash'
import store from '@vue/store';
import { mapMutations, mapGetters, mapState } from 'vuex';
export default {
  store: store,
  props: {
    sitename: {
      type: String,
      default: ''
    },
    websiteHost: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      scrollY: 0,
      scrolled: false
    };
  },
  mounted: function mounted() {
    // mt:websiteHostをstoreにセット
    this.WEBSITE_HOST(this.websiteHost);
    window.addEventListener('scroll', this.handleScroll);
  },
  computed: _objectSpread({}, mapState('app', ['pages']), {}, mapGetters('app', ['isLocal', 'getHost']), {
    isScrolled: function isScrolled() {
      if (this.scrollY > 180) {
        return 'is-scrolled';
      } else {
        return null;
      }
    },
    listStyle: function listStyle() {
      if (this.pages.length < 6) {
        var len = this.pages.length;
        var width = 100 / len;
        return {
          width: "".concat(width, "%")
        };
      } else {
        return {};
      }
    }
  }),
  methods: _objectSpread({}, mapMutations('app', ['DRAWER', 'WEBSITE_HOST']), {
    handleScroll: function handleScroll() {
      // this.scrollY = window.scrollY IEでこの書き方は動作しない
      this.scrollY = window.pageYOffset;
    },
    isActive: function isActive(id) {
      if (id == 'index') {
        switch (true) {
          case location.pathname == '/':
          case location.pathname == '/index.html':
            return 'is-active';

          default:
            return null;
        }
      } else if (id == 'educations-seminars') {
        if (new RegExp("^/(educations|seminars)").test(location.pathname)) {
          return 'is-active';
        }
      } else {
        if (new RegExp("^/".concat(id)).test(location.pathname)) {
          return 'is-active';
        }
      }
    },
    isMany: function isMany() {
      if (this.pages.length > 5) {
        return 'is-many';
      }
    }
  })
};